import sanitizeHtml from 'sanitize-html';

const defaultOptions = {
  allowedTags: [
    'b',
    'i',
    'em',
    'strong',
    'a',
    'div',
    'section',
    'article',
    'p'
  ],
  allowedAttributes: {
    'a': [ 'href' ]
  }
};

const sanitize = (dirty, options) => {
  const finalOptions = { ...defaultOptions, ...options }
  return ({
    __html: sanitizeHtml(
      dirty,
      finalOptions
    )
  });
};

function SanitizedHTML({ html, options }) {
  return (
    <div dangerouslySetInnerHTML={sanitize(html, options)} />
  );
}

export default SanitizedHTML;
